export function downloadFromLink(url: string) {
  window.location.assign(url)
}
